import CommunicationsPanel from 'src/components/ConnectedVehicle/CommunicationsPanel/CommunicationsPanel';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';

const mapStateToProps = (state: IStoreState) => ({
    connectedVehicle: state.ConnectedVehicle.ConnectedVehicleRec,
});

export default connect(mapStateToProps)(CommunicationsPanel);